//@*/*
//    *RPD Forms Appv0.91
//    * Copyright (c) 2025, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */

const folder_list = () => import("../components/folder_list.vue");
const folder = () => import("../components/folder.vue");
const files = () => import("../components/files.vue");
const home = () => import("../components/home.vue");
const ToDo = () => import("../components/ToDo.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  {
    name: "ToDo",
    path: "/ToDo",
    component: ToDo,
    display: "ToDo",
  },

  {
    name: "folder_list",
    path: "/folder_list",
    component: folder_list,
    display: "folder_list",
  },

  {
    name: "folder",
    path: "/folder",
    component: folder,
    display: "folder",
  },

  {
    name: "files",
    path: "/files",
    component: files,
    display: "files",
  },

  {
    name: "home",
    path: "/",
    component: home,
    display: "home",
  },

  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
